import React from 'react';

const Contact = ({ language }) => {
  const translations = {
    de: {
      contact_title: "Kontakt aufnehmen",
      contact_subtitle: "Offen für fachlichen Austausch, CTF-Herausforderungen, innovative Security-Themen oder neue Projekte. Schreib mir gerne direkt!",
      
      email_label: "E-Mail",
      email_val: "eliasmeisl02@gmail.com",
      email_desc: "Direkter Kanal für Anfragen, Projekte & Kooperationen.",
      email_action: "E-Mail senden &rarr;",
      
      linkedin_label: "LinkedIn",
      linkedin_val: "Elias Meisl",
      linkedin_desc: "Für professionelles Networking, Karriere-Updates und Austausch.",
      linkedin_action: "Profil besuchen &rarr;",

      location_label: "Standort & Modus",
      location_val: "Wien, Österreich",
      location_desc: "Verfügbar für Treffen im Raum Wien sowie ortsunabhängigen Remote-Austausch.",

      topics_title: "Worüber ich mich gerne austausche:",
      topics: [
        "Penetration Testing & Web Security",
        "Smart Home & HomeLab Automatisierung",
        "Active Directory & Hacking Labs",
        "AI Agents & Moderne Software Stacks",
        "CTF Challenges & IT-Security Trends"
      ]
    },
    en: {
      contact_title: "Get in Touch",
      contact_subtitle: "Open for technical discussions, CTF challenges, cybersecurity topics, or exciting project opportunities. Feel free to connect!",

      email_label: "Email",
      email_val: "eliasmeisl02@gmail.com",
      email_desc: "Direct channel for inquiries, projects, and collaboration.",
      email_action: "Send Email &rarr;",

      linkedin_label: "LinkedIn",
      linkedin_val: "Elias Meisl",
      linkedin_desc: "For professional networking, career updates, and industry chats.",
      linkedin_action: "View Profile &rarr;",

      location_label: "Location & Mode",
      location_val: "Vienna, Austria",
      location_desc: "Available for meetups in Vienna as well as remote collaboration.",

      topics_title: "Topics I'm passionate about discussing:",
      topics: [
        "Penetration Testing & Web Security",
        "Smart Home & HomeLab Automation",
        "Active Directory & Hacking Labs",
        "AI Agents & Modern Software Stacks",
        "CTF Challenges & IT Security Trends"
      ]
    }
  };

  const t = translations[language];

  return (
    <>
      <h2>{t.contact_title}</h2>
      <p style={{ maxWidth: '44rem', marginBottom: '2rem' }}>{t.contact_subtitle}</p>

      <div className="contact-grid">
        <a href="mailto:eliasmeisl02@gmail.com" className="contact-card">
          <div className="contact-card-header">
            <span className="contact-badge email-badge">Email</span>
          </div>
          <h3>{t.email_label}</h3>
          <p className="contact-main-value">{t.email_val}</p>
          <p className="contact-desc">{t.email_desc}</p>
          <span className="contact-action-btn" dangerouslySetInnerHTML={{ __html: t.email_action }} />
        </a>

        <a href="https://www.linkedin.com/in/elias-meisl-563050329" target="_blank" rel="noopener noreferrer" className="contact-card">
          <div className="contact-card-header">
            <span className="contact-badge linkedin-badge">LinkedIn</span>
          </div>
          <h3>{t.linkedin_label}</h3>
          <p className="contact-main-value">{t.linkedin_val}</p>
          <p className="contact-desc">{t.linkedin_desc}</p>
          <span className="contact-action-btn" dangerouslySetInnerHTML={{ __html: t.linkedin_action }} />
        </a>

        <div className="contact-card static-card">
          <div className="contact-card-header">
            <span className="contact-badge location-badge">Location</span>
          </div>
          <h3>{t.location_label}</h3>
          <p className="contact-main-value">{t.location_val}</p>
          <p className="contact-desc">{t.location_desc}</p>
        </div>
      </div>

      <div className="contact-topics-box">
        <h4>{t.topics_title}</h4>
        <div className="contact-topics-pills">
          {t.topics.map((topic, i) => (
            <span key={i} className="contact-topic-pill">{topic}</span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Contact;